import { render } from "./ProfileImage.vue?vue&type=template&id=06f466c6&scoped=true"
import script from "./ProfileImage.vue?vue&type=script&lang=js"
export * from "./ProfileImage.vue?vue&type=script&lang=js"

import "./ProfileImage.vue?vue&type=style&index=0&id=06f466c6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f466c6"]])

export default __exports__